import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import DestroyCompensationMutation from 'buyside/graphql/mutations/DestroyCompensation';

import DeleteDraftCompensationButton from 'buyside/components/presentation/UserAccount/PostedCompensations/deleteDraftCompensationButton';

const DeleteDraftCompensationButtonContainer = ({ actualCompensation: { id } }) => (
  <Mutation mutation={DestroyCompensationMutation}>
    {mutate => {
      const destroyCompensation = id => mutate({ variables: { id } });
      return <DeleteDraftCompensationButton destroyCompensation={destroyCompensation} id={id} />;
    }}
  </Mutation>
);

export default DeleteDraftCompensationButtonContainer;
